import { render, staticRenderFns } from "./Deposite.vue?vue&type=template&id=1df2442e&scoped=true"
import script from "./Deposite.vue?vue&type=script&lang=js"
export * from "./Deposite.vue?vue&type=script&lang=js"
import style0 from "./Deposite.vue?vue&type=style&index=0&id=1df2442e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df2442e",
  null
  
)

export default component.exports